module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "no-data-text": "No invoices."
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "flat": "",
            "depressed": "",
            "small": "",
            "left": "",
            "href": props.item.invoice_path,
            "target": "_blank"
          }
        }, [_vm._v("view invoice")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user ? props.item.user.name : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status ? props.item.status : 'pending'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.$can('mark-paid', 'invoices') && props.item.status === 'pending') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.markPaid(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v("\n          Mark paid\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('AddCaseInvoiceButton', _vm._g({
          attrs: {
            "casesid": _vm.casesid
          }
        }, on))]
      }
    }])
  }, [_vm._v("\n    Add Case Invoice\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe08a22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseInvoicesDataTable.vue
// module id = 1006
// module chunks = 1